(function () {
  if (window.__gtCartPdfExportBound) return;
  window.__gtCartPdfExportBound = true;

  var cartCheckTimer = null;
  var FRAME_MM = 5;

  var PDF_FONT = {
    family: 'helvetica',
    boldStyle: 'bold',
    unicodeReady: false
  };

  var COLORS = {
    lightGray: [239, 240, 240],
    white: [255, 255, 255],
    darkText: [55, 55, 55],
    accent: [170, 16, 69],
    lineGray: [214, 214, 214],
    linkBlue: [0, 92, 176]
  };

  var DEFAULT_I18N = {
    language: 'de',
    dateLocale: 'de-DE',
    catalogTitle: 'Produkt Katalog',
    footerRights: 'Alle Rechte vorbehalten.',
    footerWebsite: 'www.gluetec-group.com',
    footerWebsiteUrl: 'https://www.gluetec-group.com',
    footerEmail: 'info.de@gluetec-group.com',
    footerEmailUrl: 'mailto:info.de@gluetec-group.com',
    page: 'Seite',
    description: 'Beschreibung',
    productImage: 'Produktbild',
    properties: 'Eigenschaften',
    furtherData: 'Weitere Daten',
    onRequest: 'auf Anfrage',
    variants: 'Varianten',
    sku: 'SKU',
    vpe: 'VPE',
    packagingSize: 'Gebindegröße',
    packagingType: 'Gebindeart',
    moreVariants: 'Weitere Varianten',
    downloads: 'Downloads',
    productButton: 'Zur Produktseite',
    tocTitle: 'Inhaltsverzeichnis',
    tocContinuation: 'Inhaltsverzeichnis (Fortsetzung)',
    name: 'Name',
    untitledProduct: 'Unbenanntes Produkt',
    uncategorizedCollection: 'Produkte',
    emptyCart: 'Ihr Warenkorb ist aktuell leer.',
    loading: 'Katalog wird erstellt …',
    openWindowTitle: 'Katalog wird erstellt',
    createFailed: 'Der Katalog konnte nicht erstellt werden.',
    filenamePrefix: 'produkt-katalog',
    disableJustify: false
  };

  function transliteratePolish(text) {
    return String(text || '')
      .replace(/ą/g, 'a')
      .replace(/ć/g, 'c')
      .replace(/ę/g, 'e')
      .replace(/ł/g, 'l')
      .replace(/ń/g, 'n')
      .replace(/ó/g, 'o')
      .replace(/ś/g, 's')
      .replace(/ź/g, 'z')
      .replace(/ż/g, 'z')
      .replace(/Ą/g, 'A')
      .replace(/Ć/g, 'C')
      .replace(/Ę/g, 'E')
      .replace(/Ł/g, 'L')
      .replace(/Ń/g, 'N')
      .replace(/Ó/g, 'O')
      .replace(/Ś/g, 'S')
      .replace(/Ź/g, 'Z')
      .replace(/Ż/g, 'Z');
  }

  function decodeHtmlEntities(text) {
    var value = String(text || '');

    if (value.indexOf('&') === -1) {
      return value;
    }

    if (typeof document !== 'undefined' && document.createElement) {
      var textarea = document.createElement('textarea');
      textarea.innerHTML = value;
      return textarea.value;
    }

    return value
      .replace(/&amp;/g, '&')
      .replace(/&nbsp;/g, ' ')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  }

  function safePdfText(text, i18n) {
    var value = decodeHtmlEntities(String(text || '')).replace(/\u00a0/g, ' ');

    if (i18n && i18n.language === 'pl' && !PDF_FONT.unicodeReady) {
      return transliteratePolish(value);
    }

    return value;
  }

  function safePdfLines(lines, i18n) {
    if (!Array.isArray(lines)) return [];

    return lines.map(function (line) {
      return safePdfText(line, i18n);
    });
  }

  function setPdfFont(doc, style) {
    var selectedStyle = style === 'bold' ? PDF_FONT.boldStyle : 'normal';

    try {
      doc.setFont(PDF_FONT.family, selectedStyle);
    } catch (error) {
      PDF_FONT.family = 'helvetica';
      PDF_FONT.boldStyle = 'bold';
      PDF_FONT.unicodeReady = false;
      doc.setFont('helvetica', style === 'bold' ? 'bold' : 'normal');
    }

    if (typeof doc.setCharSpace === 'function') {
      doc.setCharSpace(0);
    }
  }

  function getI18n(payload) {
    var source = payload && payload.i18n ? payload.i18n : {};
    var merged = {};

    Object.keys(DEFAULT_I18N).forEach(function (key) {
      if (source[key] !== undefined && source[key] !== null) {
        merged[key] = source[key];
      } else {
        merged[key] = DEFAULT_I18N[key];
      }
    });

    if (payload && payload.language) {
      merged.language = payload.language;
    }

    if (merged.language === 'pl') {
      merged.footerEmail = 'info.pl@gluetec-group.com';
      merged.footerEmailUrl = 'mailto:info.pl@gluetec-group.com';
    } else {
      merged.footerEmail = 'info.de@gluetec-group.com';
      merged.footerEmailUrl = 'mailto:info.de@gluetec-group.com';
    }

    return merged;
  }

  function getRootFromNode(node) {
    return node && node.closest ? node.closest('.gt-cart-pdf-export') : null;
  }

  function parsePayload(root) {
    var dataEl = root ? root.querySelector('.gt-cart-pdf-export__data') : null;

    if (!dataEl) {
      return {
        items: [],
        frontPdfUrl: null,
        backPdfUrl: null,
        downloadIconUrl: null,
        pdfFontRegularUrl: null,
        pdfFontBoldUrl: null,
        i18n: DEFAULT_I18N
      };
    }

    try {
      var payload = JSON.parse(dataEl.textContent || '{}');
      payload.i18n = getI18n(payload);
      return payload;
    } catch (error) {
      console.error('GT Catalog JSON Error:', error);

      return {
        items: [],
        frontPdfUrl: null,
        backPdfUrl: null,
        downloadIconUrl: null,
        pdfFontRegularUrl: null,
        pdfFontBoldUrl: null,
        i18n: DEFAULT_I18N
      };
    }
  }

  function getCartUrl() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root)
      ? window.Shopify.routes.root + 'cart.js'
      : '/cart.js';
  }

  function normalizeWhitespace(text) {
    return decodeHtmlEntities(String(text || ''))
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function normalizeMetafieldValue(value) {
    if (value === null || value === undefined) return '';

    if (Array.isArray(value)) {
      return value
        .map(function (entry) { return normalizeMetafieldValue(entry); })
        .filter(Boolean)
        .join(', ');
    }

    if (typeof value === 'object') {
      if ('value' in value) {
        return normalizeMetafieldValue(value.value);
      }

      return Object.keys(value)
        .map(function (key) { return normalizeMetafieldValue(value[key]); })
        .filter(Boolean)
        .join(', ');
    }

    return normalizeWhitespace(value);
  }

  function extractTextFromRichText(children) {
    var text = '';

    function walk(nodes) {
      if (!Array.isArray(nodes)) return;

      for (var i = 0; i < nodes.length; i++) {
        var node = nodes[i];
        if (!node) continue;

        if (node.type === 'text') {
          text += node.value || '';
        } else if (node.type === 'hard_break') {
          text += '\n';
        } else if (Array.isArray(node.children)) {
          walk(node.children);
        }
      }
    }

    walk(children);
    return text;
  }

  function richTextToPlainText(rawValue) {
    if (!rawValue) return '';

    if (typeof rawValue === 'string') {
      return rawValue
        .replace(/\r/g, '')
        .split('\n')
        .map(function (line) { return line.trim(); })
        .filter(Boolean)
        .join('\n');
    }

    if (typeof rawValue !== 'object') return '';

    var blocks = [];

    function pushBlock(text, options) {
      var clean = String(text || '')
        .replace(/\r/g, '')
        .split('\n')
        .map(function (line) { return line.trim(); })
        .filter(function (line) { return line.length > 0; });

      for (var i = 0; i < clean.length; i++) {
        if (options && options.bullet) {
          blocks.push('• ' + clean[i]);
        } else {
          blocks.push(clean[i]);
        }
      }
    }

    function walk(node) {
      if (!node) return;

      if (Array.isArray(node)) {
        for (var i = 0; i < node.length; i++) {
          walk(node[i]);
        }
        return;
      }

      if (node.type === 'root') {
        walk(node.children || []);
        return;
      }

      if (node.type === 'paragraph') {
        pushBlock(extractTextFromRichText(node.children || []));
        return;
      }

      if (node.type === 'heading') {
        pushBlock(extractTextFromRichText(node.children || []));
        return;
      }

      if (node.type === 'list') {
        walk(node.children || []);
        return;
      }

      if (node.type === 'list-item') {
        pushBlock(extractTextFromRichText(node.children || []), { bullet: true });
        return;
      }

      if (Array.isArray(node.children)) {
        walk(node.children);
      }
    }

    walk(rawValue);
    return blocks.join('\n');
  }

  function mergeInlineSegments(segments) {
    var merged = [];

    if (!Array.isArray(segments)) return merged;

    segments.forEach(function (segment) {
      if (!segment || segment.text === undefined || segment.text === null) return;

      var text = decodeHtmlEntities(String(segment.text || '')).replace(/\u00a0/g, ' ');
      if (!text) return;

      var bold = segment.bold === true;

      if (merged.length && merged[merged.length - 1].bold === bold) {
        merged[merged.length - 1].text += text;
      } else {
        merged.push({
          text: text,
          bold: bold
        });
      }
    });

    return merged;
  }

  function trimInlineSegments(segments) {
    var list = mergeInlineSegments(segments);

    while (list.length && !String(list[0].text || '').trim()) {
      list.shift();
    }

    while (list.length && !String(list[list.length - 1].text || '').trim()) {
      list.pop();
    }

    if (list.length) {
      list[0].text = String(list[0].text || '').replace(/^\s+/, '');
      list[list.length - 1].text = String(list[list.length - 1].text || '').replace(/\s+$/, '');
    }

    return mergeInlineSegments(list).filter(function (segment) {
      return String(segment.text || '').length > 0;
    });
  }

  function getInlineSegmentsText(segments) {
    return (Array.isArray(segments) ? segments : [])
      .map(function (segment) { return segment && segment.text ? segment.text : ''; })
      .join('');
  }

  function nodeHasBoldMark(node) {
    if (!node) return false;

    if (node.bold === true || node.strong === true) return true;

    var marks = Array.isArray(node.marks) ? node.marks : [];
    for (var i = 0; i < marks.length; i++) {
      var mark = marks[i];

      if (mark === 'bold') return true;
      if (mark && (mark.type === 'bold' || mark.name === 'bold')) return true;
    }

    return false;
  }

  function extractInlineSegments(node, inheritedBold) {
    var segments = [];

    function walk(current, boldContext) {
      if (!current) return;

      if (Array.isArray(current)) {
        for (var i = 0; i < current.length; i++) {
          walk(current[i], boldContext);
        }
        return;
      }

      var isBold = boldContext === true || nodeHasBoldMark(current);

      if (current.type === 'text') {
        segments.push({
          text: current.value || '',
          bold: isBold
        });
        return;
      }

      if (current.type === 'hard_break') {
        segments.push({
          text: '\n',
          bold: isBold
        });
        return;
      }

      if (Array.isArray(current.children)) {
        walk(current.children, isBold);
      }
    }

    walk(node, inheritedBold === true);
    return trimInlineSegments(segments);
  }

  function extractInlineText(node) {
    return getInlineSegmentsText(extractInlineSegments(node, false));
  }

  function htmlStringToInlineSegments(value) {
    var source = String(value || '').replace(/\r/g, '');
    var hasTags = /<\s*\/?\s*(strong|b|br|p|div|span|ul|ol|li|h[1-6])[\s>]/i.test(source);

    if (!hasTags || typeof document === 'undefined' || !document.createElement) {
      return trimInlineSegments([
        {
          text: source,
          bold: false
        }
      ]);
    }

    var wrapper = document.createElement('div');
    wrapper.innerHTML = source;

    var segments = [];

    function walkDom(node, boldContext) {
      if (!node) return;

      if (node.nodeType === 3) {
        segments.push({
          text: node.nodeValue || '',
          bold: boldContext === true
        });
        return;
      }

      if (node.nodeType !== 1) return;

      var tagName = String(node.tagName || '').toLowerCase();
      var nextBold = boldContext === true || tagName === 'strong' || tagName === 'b';

      if (tagName === 'br') {
        segments.push({
          text: '\n',
          bold: nextBold
        });
        return;
      }

      var children = node.childNodes || [];
      for (var i = 0; i < children.length; i++) {
        walkDom(children[i], nextBold);
      }

      if (tagName === 'p' || tagName === 'div' || tagName === 'li' || /^h[1-6]$/.test(tagName)) {
        segments.push({
          text: '\n',
          bold: nextBold
        });
      }
    }

    for (var i = 0; i < wrapper.childNodes.length; i++) {
      walkDom(wrapper.childNodes[i], false);
    }

    return trimInlineSegments(segments);
  }

  function richTextToBlocks(rawValue) {
    var blocks = [];

    function push(type, text, extra) {
      var sourceSegments = extra && Array.isArray(extra.segments)
        ? extra.segments
        : [
            {
              text: text,
              bold: false
            }
          ];

      var segments = trimInlineSegments(sourceSegments);
      var clean = normalizeWhitespace(text || getInlineSegmentsText(segments));

      if (!clean) return;

      var block = {
        type: type,
        text: clean,
        segments: segments.length
          ? segments
          : [
              {
                text: clean,
                bold: false
              }
            ]
      };

      if (extra) {
        Object.keys(extra).forEach(function (key) {
          if (key !== 'segments') {
            block[key] = extra[key];
          }
        });
      }

      blocks.push(block);
    }

    if (!rawValue) return blocks;

    if (typeof rawValue === 'string') {
      rawValue
        .replace(/\r/g, '')
        .split(/\n{2,}/)
        .map(function (part) { return part.trim(); })
        .filter(Boolean)
        .forEach(function (paragraph) {
          var segments = htmlStringToInlineSegments(paragraph);
          push('paragraph', getInlineSegmentsText(segments), {
            segments: segments
          });
        });

      return blocks;
    }

    function walk(node, listContext) {
      if (!node) return;

      if (Array.isArray(node)) {
        for (var i = 0; i < node.length; i++) {
          walk(node[i], listContext);
        }
        return;
      }

      if (node.type === 'root') {
        walk(node.children || [], listContext);
        return;
      }

      if (node.type === 'heading') {
        var headingSegments = extractInlineSegments(node.children || [], false);
        push('heading', getInlineSegmentsText(headingSegments), {
          level: node.level || 2,
          segments: headingSegments
        });
        return;
      }

      if (node.type === 'paragraph') {
        var paragraphSegments = extractInlineSegments(node.children || [], false);
        push('paragraph', getInlineSegmentsText(paragraphSegments), {
          segments: paragraphSegments
        });
        return;
      }

      if (node.type === 'list') {
        var ordered = node.listType === 'ordered' || node.listType === 'numbered';
        var children = node.children || [];

        for (var j = 0; j < children.length; j++) {
          walk(children[j], {
            ordered: ordered,
            index: j + 1
          });
        }

        return;
      }

      if (node.type === 'list-item') {
        var label = listContext && listContext.ordered
          ? String(listContext.index || 1) + '.'
          : '•';

        var bulletSegments = extractInlineSegments(node.children || [], false);

        push('bullet', getInlineSegmentsText(bulletSegments), {
          bulletLabel: label,
          segments: bulletSegments
        });

        return;
      }

      if (Array.isArray(node.children)) {
        walk(node.children, listContext);
      }
    }

    walk(rawValue, null);

    return blocks;
  }

  function normalizeCollection(raw, i18n) {
    raw = raw || {};

    var fallbackTitle = i18n && i18n.uncategorizedCollection
      ? i18n.uncategorizedCollection
      : 'Produkte';

    return {
      id: normalizeWhitespace(raw.id) || normalizeWhitespace(raw.handle) || normalizeWhitespace(raw.title) || 'uncategorized',
      title: normalizeWhitespace(raw.title) || fallbackTitle,
      handle: normalizeWhitespace(raw.handle),
      url: normalizeWhitespace(raw.url),
      isProductGroup: raw.isProductGroup === true || raw.isProductGroup === 'true',
      headerImageUrl: normalizeWhitespace(raw.headerImageUrl),
      footerImageUrl: normalizeWhitespace(raw.footerImageUrl),
      catalogTextRichText: raw.catalogTextRichText || null,
      headerImage: null,
      footerImage: null
    };
  }

  function collectionHasIntroData(collection) {
    return !!(
      collection &&
      (
        collection.headerImageUrl ||
        collection.footerImageUrl ||
        collection.catalogTextRichText
      )
    );
  }

  function isProductGroupCollection(collection) {
    return !!(collection && collection.isProductGroup === true);
  }

  function getUncategorizedCollection(i18n) {
    return normalizeCollection({
      id: 'uncategorized',
      title: i18n.uncategorizedCollection
    }, i18n);
  }

  function selectPrimaryCollection(product, i18n) {
    var collections = Array.isArray(product.collections) ? product.collections : [];

    /*
      GLUETEC Anpassung:
      Für die Katalog-Gruppierung werden ausschließlich Collections berücksichtigt,
      die im Liquid aus dem Menüzweig "Produktgruppen" übergeben wurden.
      Collections aus "Branchen & Anwendungen" oder anderen Menübereichen
      werden hier bewusst ignoriert.
    */
    var productGroupCollections = collections.filter(isProductGroupCollection);

    for (var i = 0; i < productGroupCollections.length; i++) {
      if (collectionHasIntroData(productGroupCollections[i])) {
        return productGroupCollections[i];
      }
    }

    if (productGroupCollections.length) {
      return productGroupCollections[0];
    }

    return getUncategorizedCollection(i18n);
  }

  function uniqueProductsFromPayload(root) {
    var payload = parsePayload(root);
    var i18n = getI18n(payload);
    var rawItems = Array.isArray(payload.items) ? payload.items : [];
    var map = {};

    rawItems.forEach(function (item) {
      var productId = String(item.productId || '');
      if (!productId) return;

      if (!map[productId]) {
        var collections = Array.isArray(item.collections)
          ? item.collections.map(function (collection) {
              return normalizeCollection(collection, i18n);
            })
          : [];

        map[productId] = {
          productId: productId,
          title: normalizeWhitespace(item.title),
          productUrl: normalizeWhitespace(item.productUrl),
          imageUrl: normalizeWhitespace(item.imageUrl),
          description: normalizeWhitespace(item.description),
          catalogDescriptionRichText: item.catalogDescriptionRichText || null,
          collections: collections,
          primaryCollection: null,
          properties: Array.isArray(item.properties)
            ? item.properties
                .map(function (property) {
                  return {
                    label: normalizeWhitespace(property && property.label),
                    value: normalizeMetafieldValue(property && property.value)
                  };
                })
                .filter(function (property) {
                  return property.label && property.value;
                })
            : [],
          variants: Array.isArray(item.variants)
            ? item.variants
                .map(function (variant) {
                  return {
                    title: normalizeWhitespace(variant && variant.title),
                    sku: normalizeWhitespace(variant && variant.sku),
                    vpe: normalizeMetafieldValue(variant && variant.vpe),
                    gebindegrosse: normalizeMetafieldValue(variant && variant.gebindegrosse),
                    gebinde: normalizeMetafieldValue(variant && variant.gebinde)
                  };
                })
                .filter(function (variant) {
                  return variant.sku || variant.vpe || variant.gebindegrosse || variant.gebinde || variant.title;
                })
            : [],
          downloads: Array.isArray(item.downloads)
            ? item.downloads
                .map(function (download) {
                  return {
                    label: normalizeWhitespace(download && download.label),
                    url: normalizeWhitespace(download && download.url)
                  };
                })
                .filter(function (download) {
                  return download.label && download.url;
                })
            : []
        };
      }
    });

    return Object.keys(map).map(function (key) {
      return map[key];
    });
  }

  function buildCatalogSections(products, i18n) {
    var sections = [];
    var map = {};

    products.forEach(function (product) {
      var collection = selectPrimaryCollection(product, i18n);
      var key = collection.id || collection.handle || collection.title || 'uncategorized';

      product.primaryCollection = collection;

      if (!map[key]) {
        map[key] = {
          collection: collection,
          products: [],
          introLayoutPages: [],
          introPageCount: 1
        };

        sections.push(map[key]);
      }

      map[key].products.push(product);
    });

    return sections;
  }

  function getTodayForFilename() {
    var now = new Date();
    var year = now.getFullYear();
    var month = String(now.getMonth() + 1).padStart(2, '0');
    var day = String(now.getDate()).padStart(2, '0');
    return year + '-' + month + '-' + day;
  }

  function getDateForFooter(i18n) {
    return new Date().toLocaleDateString((i18n && i18n.dateLocale) || 'de-DE');
  }

  function getCurrentYear() {
    return new Date().getFullYear();
  }

  function blobToDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var reader = new FileReader();
      reader.onloadend = function () { resolve(reader.result); };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  function getImageDimensions(dataUrl) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.onload = function () {
        resolve({
          width: img.naturalWidth || img.width,
          height: img.naturalHeight || img.height
        });
      };
      img.onerror = reject;
      img.src = dataUrl;
    });
  }

  async function loadImageData(url) {
    if (!url) return null;

    try {
      var response = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!response.ok) throw new Error('Image request failed');

      var blob = await response.blob();
      var dataUrl = await blobToDataUrl(blob);
      var dimensions = await getImageDimensions(dataUrl);

      return {
        dataUrl: dataUrl,
        width: dimensions.width,
        height: dimensions.height,
        format: (blob.type && blob.type.indexOf('png') !== -1) ? 'PNG' : 'JPEG'
      };
    } catch (error) {
      console.warn('Bild konnte nicht geladen werden:', url, error);
      return null;
    }
  }

  async function enrichCatalogAssets(sections, downloadIconUrl) {
    var downloadIcon = downloadIconUrl ? await loadImageData(downloadIconUrl) : null;
    var collectionImageCache = {};
    var productImageCache = {};

    for (var s = 0; s < sections.length; s++) {
      var collection = sections[s].collection;

      if (collection.headerImageUrl) {
        if (!collectionImageCache[collection.headerImageUrl]) {
          collectionImageCache[collection.headerImageUrl] = await loadImageData(collection.headerImageUrl);
        }

        collection.headerImage = collectionImageCache[collection.headerImageUrl];
      }

      if (collection.footerImageUrl) {
        if (!collectionImageCache[collection.footerImageUrl]) {
          collectionImageCache[collection.footerImageUrl] = await loadImageData(collection.footerImageUrl);
        }

        collection.footerImage = collectionImageCache[collection.footerImageUrl];
      }

      for (var p = 0; p < sections[s].products.length; p++) {
        var product = sections[s].products[p];

        if (product.imageUrl) {
          if (!productImageCache[product.imageUrl]) {
            productImageCache[product.imageUrl] = await loadImageData(product.imageUrl);
          }

          product.image = productImageCache[product.imageUrl];
        } else {
          product.image = null;
        }
      }
    }

    return {
      sections: sections,
      downloadIcon: downloadIcon
    };
  }

  function loadJsPDF() {
    if (window.jspdf && window.jspdf.jsPDF) {
      return Promise.resolve(window.jspdf.jsPDF);
    }

    if (window.__gtCartJsPdfPromise) {
      return window.__gtCartJsPdfPromise;
    }

    window.__gtCartJsPdfPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-gt-jspdf="true"]');

      if (existing) {
        existing.addEventListener('load', function () {
          if (window.jspdf && window.jspdf.jsPDF) {
            resolve(window.jspdf.jsPDF);
          } else {
            reject(new Error('jsPDF geladen, aber nicht verfügbar.'));
          }
        }, { once: true });

        existing.addEventListener('error', function () {
          reject(new Error('jsPDF konnte nicht geladen werden.'));
        }, { once: true });

        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jspdf/2.5.1/jspdf.umd.min.js';
      script.async = true;
      script.dataset.gtJspdf = 'true';

      script.onload = function () {
        if (window.jspdf && window.jspdf.jsPDF) {
          resolve(window.jspdf.jsPDF);
        } else {
          reject(new Error('jsPDF geladen, aber nicht verfügbar.'));
        }
      };

      script.onerror = function () {
        reject(new Error('jsPDF konnte nicht geladen werden.'));
      };

      document.head.appendChild(script);
    });

    return window.__gtCartJsPdfPromise;
  }

  function loadPdfLib() {
    if (window.PDFLib && window.PDFLib.PDFDocument) {
      return Promise.resolve(window.PDFLib);
    }

    if (window.__gtCartPdfLibPromise) {
      return window.__gtCartPdfLibPromise;
    }

    window.__gtCartPdfLibPromise = new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[data-gt-pdflib="true"]');

      if (existing) {
        existing.addEventListener('load', function () {
          if (window.PDFLib && window.PDFLib.PDFDocument) {
            resolve(window.PDFLib);
          } else {
            reject(new Error('pdf-lib geladen, aber nicht verfügbar.'));
          }
        }, { once: true });

        existing.addEventListener('error', function () {
          reject(new Error('pdf-lib konnte nicht geladen werden.'));
        }, { once: true });

        return;
      }

      var script = document.createElement('script');
      script.src = 'https://cdnjs.cloudflare.com/ajax/libs/pdf-lib/1.17.1/pdf-lib.min.js';
      script.async = true;
      script.dataset.gtPdflib = 'true';

      script.onload = function () {
        if (window.PDFLib && window.PDFLib.PDFDocument) {
          resolve(window.PDFLib);
        } else {
          reject(new Error('pdf-lib geladen, aber nicht verfügbar.'));
        }
      };

      script.onerror = function () {
        reject(new Error('pdf-lib konnte nicht geladen werden.'));
      };

      document.head.appendChild(script);
    });

    return window.__gtCartPdfLibPromise;
  }

  async function fetchArrayBuffer(url) {
    if (!url) {
      throw new Error('Keine Datei-URL übergeben.');
    }

    var response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      cache: 'force-cache'
    });

    if (!response.ok) {
      throw new Error('Datei konnte nicht geladen werden: ' + response.status + ' - ' + url);
    }

    return response.arrayBuffer();
  }

  function arrayBufferToBase64(buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    var chunkSize = 0x8000;

    for (var i = 0; i < bytes.length; i += chunkSize) {
      var chunk = bytes.subarray(i, i + chunkSize);
      binary += String.fromCharCode.apply(null, chunk);
    }

    return btoa(binary);
  }

  async function registerPdfFonts(doc, payload) {
    PDF_FONT.family = 'helvetica';
    PDF_FONT.boldStyle = 'bold';
    PDF_FONT.unicodeReady = false;

    if (!payload || !payload.pdfFontRegularUrl) {
      console.warn('GT PDF Font: Keine Font-URL vorhanden. Fallback auf Helvetica.');
      return;
    }

    try {
      var regularBytes = await fetchArrayBuffer(payload.pdfFontRegularUrl);

      if (!regularBytes || regularBytes.byteLength < 10000) {
        throw new Error('Regular-Font ist ungültig oder zu klein.');
      }

      var regularBase64 = arrayBufferToBase64(regularBytes);

      doc.addFileToVFS('GT-Regular.ttf', regularBase64);
      doc.addFont('GT-Regular.ttf', 'GTPdfFont', 'normal');

      var boldLoaded = false;

      if (payload.pdfFontBoldUrl) {
        try {
          var boldBytes = await fetchArrayBuffer(payload.pdfFontBoldUrl);

          if (!boldBytes || boldBytes.byteLength < 10000) {
            throw new Error('Bold-Font ist ungültig oder zu klein.');
          }

          var boldBase64 = arrayBufferToBase64(boldBytes);

          doc.addFileToVFS('GT-Bold.ttf', boldBase64);
          doc.addFont('GT-Bold.ttf', 'GTPdfFont', 'bold');
          boldLoaded = true;
        } catch (boldError) {
          console.warn('GT PDF Font Bold konnte nicht geladen werden:', boldError);
        }
      }

      PDF_FONT.family = 'GTPdfFont';
      PDF_FONT.boldStyle = boldLoaded ? 'bold' : 'normal';

      try {
        setPdfFont(doc, 'normal');
        doc.setFontSize(8);
        doc.getTextWidth('Zażółć gęślą jaźń Właściwości');

        setPdfFont(doc, 'bold');
        doc.setFontSize(8);
        doc.getTextWidth('Zażółć gęślą jaźń Właściwości');

        PDF_FONT.unicodeReady = true;
      } catch (validationError) {
        console.warn('GT PDF Font geladen, aber für jsPDF nicht nutzbar. Fallback auf Helvetica:', validationError);

        PDF_FONT.family = 'helvetica';
        PDF_FONT.boldStyle = 'bold';
        PDF_FONT.unicodeReady = false;

        setPdfFont(doc, 'normal');
      }
    } catch (error) {
      console.warn('GT PDF Font konnte nicht geladen werden. Fallback auf Helvetica:', error);

      PDF_FONT.family = 'helvetica';
      PDF_FONT.boldStyle = 'bold';
      PDF_FONT.unicodeReady = false;

      setPdfFont(doc, 'normal');
    }
  }

  function fitImage(image, maxWidth, maxHeight) {
    if (!image || !image.width || !image.height) {
      return { width: 0, height: 0 };
    }

    var ratio = Math.min(maxWidth / image.width, maxHeight / image.height);

    return {
      width: image.width * ratio,
      height: image.height * ratio
    };
  }

  function fitLines(doc, text, maxWidth, maxHeight, lineHeight, i18n) {
    if (!text) return [];

    var cleanText = safePdfText(text, i18n);
    var lines = doc.splitTextToSize(cleanText, maxWidth);
    var maxLines = Math.max(1, Math.floor(maxHeight / lineHeight));

    if (lines.length <= maxLines) {
      return lines;
    }

    var clipped = lines.slice(0, maxLines);
    var lastIndex = clipped.length - 1;
    var lastLine = clipped[lastIndex];

    while (lastLine.length > 0 && doc.getTextWidth(lastLine + ' …') > maxWidth) {
      lastLine = lastLine.slice(0, -1);
    }

    clipped[lastIndex] = (lastLine || '').trim() + ' …';
    return clipped;
  }

  function getDescriptionLayout(doc, text, width, maxHeight, i18n) {
    var clean = normalizeWhitespace(safePdfText(text || '', i18n));

    if (!clean) {
      return {
        fontSize: 9,
        lineHeight: 4.2,
        lines: [],
        height: 0
      };
    }

    var isPolish = i18n && i18n.language === 'pl';
    var fontCandidates = isPolish
      ? [8.1, 7.8, 7.5, 7.2, 6.9, 6.6, 6.3]
      : [9, 8.7, 8.4, 8.1, 7.8, 7.5, 7.2, 6.9, 6.6, 6.3];

    var fallback = null;

    for (var i = 0; i < fontCandidates.length; i++) {
      var fontSize = fontCandidates[i];
      var lineHeight = Math.max(3.0, fontSize * 0.47);

      setPdfFont(doc, 'normal');
      doc.setFontSize(fontSize);

      var lines = doc.splitTextToSize(clean, width);
      var height = lines.length * lineHeight;

      fallback = {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: lines,
        height: height
      };

      if (height <= maxHeight) {
        return fallback;
      }
    }

    return fallback;
  }

  function getProductDescriptionBlocks(product) {
    var richBlocks = richTextToBlocks(product && product.catalogDescriptionRichText);

    if (richBlocks && richBlocks.length) {
      return richBlocks;
    }

    var fallbackText = normalizeWhitespace(product && product.description);

    if (!fallbackText) return [];

    return [
      {
        type: 'paragraph',
        text: fallbackText
      }
    ];
  }

  function getProductDescriptionBlockStyle(block, i18n, scale) {
    var isPolish = i18n && i18n.language === 'pl';
    var factor = scale || 1;

    if (block.type === 'heading') {
      return {
        fontStyle: 'bold',
        fontSize: ((block.level && block.level <= 2) ? 9.6 : 8.8) * factor,
        lineHeight: ((block.level && block.level <= 2) ? 4.7 : 4.3) * factor,
        gapBefore: 2.6 * factor,
        gapAfter: 1.5 * factor,
        textIndent: 0,
        bulletIndent: 0
      };
    }

    if (block.type === 'bullet') {
      return {
        fontStyle: 'normal',
        fontSize: (isPolish ? 7.0 : 7.4) * factor,
        lineHeight: (isPolish ? 3.45 : 3.65) * factor,
        gapBefore: 0.7 * factor,
        gapAfter: 0.7 * factor,
        textIndent: 4.8,
        bulletIndent: 0
      };
    }

    return {
      fontStyle: 'normal',
      fontSize: (isPolish ? 7.1 : 7.5) * factor,
      lineHeight: (isPolish ? 3.5 : 3.7) * factor,
      gapBefore: 1.8 * factor,
      gapAfter: 1.2 * factor,
      textIndent: 0,
      bulletIndent: 0
    };
  }


  function getCaseLocale(i18n) {
    if (!i18n || !i18n.language) return 'de-DE';
    if (i18n.language === 'en') return 'en-GB';
    if (i18n.language === 'pl') return 'pl-PL';
    return 'de-DE';
  }

  function formatCollectionTitle(title, i18n) {
    var cleanTitle = normalizeWhitespace(title);
    if (!cleanTitle) return '';
    return cleanTitle.toLocaleUpperCase(getCaseLocale(i18n));
  }

  function getSegmentFontStyle(defaultFontStyle, segment) {
    if (segment && segment.bold === true) return 'bold';
    return defaultFontStyle === 'bold' ? 'bold' : 'normal';
  }

  function getStyledTextWidth(doc, text, defaultFontStyle, fontSize, segment) {
    setPdfFont(doc, getSegmentFontStyle(defaultFontStyle, segment));
    doc.setFontSize(fontSize);
    return doc.getTextWidth(text || '');
  }

  function cloneRichLine(line) {
    if (!line || !Array.isArray(line.segments)) {
      return {
        text: String(line || ''),
        segments: [
          {
            text: String(line || ''),
            bold: false
          }
        ]
      };
    }

    return {
      text: line.text || getInlineSegmentsText(line.segments),
      segments: line.segments.map(function (segment) {
        return {
          text: segment.text || '',
          bold: segment.bold === true
        };
      })
    };
  }

  function makeRichLineFromSegments(segments) {
    var cleanSegments = trimInlineSegments(segments);

    return {
      text: getInlineSegmentsText(cleanSegments),
      segments: cleanSegments
    };
  }

  function getRichLineText(line) {
    if (!line) return '';
    if (Array.isArray(line.segments)) return getInlineSegmentsText(line.segments);
    return String(line || '');
  }

  function tokenizeInlineSegments(segments, i18n) {
    var tokens = [];

    (Array.isArray(segments) ? segments : []).forEach(function (segment) {
      var text = safePdfText(segment && segment.text ? segment.text : '', i18n)
        .replace(/\r/g, '')
        .replace(/\u00a0/g, ' ');

      var parts = text.split(/(\n|\s+)/);

      parts.forEach(function (part) {
        if (!part) return;

        if (part.indexOf('\n') !== -1) {
          tokens.push({
            type: 'break'
          });
          return;
        }

        if (/^\s+$/.test(part)) {
          tokens.push({
            type: 'space',
            text: ' ',
            bold: segment && segment.bold === true
          });
          return;
        }

        tokens.push({
          type: 'text',
          text: part,
          bold: segment && segment.bold === true
        });
      });
    });

    return tokens;
  }

  function wrapRichTextLines(doc, block, maxWidth, style, i18n) {
    var defaultFontStyle = style && style.fontStyle === 'bold' ? 'bold' : 'normal';
    var fontSize = style && style.fontSize ? style.fontSize : 8;
    var sourceSegments = block && Array.isArray(block.segments) && block.segments.length
      ? block.segments
      : [
          {
            text: block && block.text ? block.text : '',
            bold: false
          }
        ];

    var tokens = tokenizeInlineSegments(sourceSegments, i18n);
    var lines = [];
    var currentSegments = [];
    var currentWidth = 0;

    function pushToken(text, bold) {
      if (!text) return;

      if (currentSegments.length && currentSegments[currentSegments.length - 1].bold === (bold === true)) {
        currentSegments[currentSegments.length - 1].text += text;
      } else {
        currentSegments.push({
          text: text,
          bold: bold === true
        });
      }

      currentWidth += getStyledTextWidth(doc, text, defaultFontStyle, fontSize, { bold: bold === true });
    }

    function pushLine() {
      var line = makeRichLineFromSegments(currentSegments);

      if (line.segments.length && normalizeWhitespace(line.text)) {
        lines.push(line);
      }

      currentSegments = [];
      currentWidth = 0;
    }

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (token.type === 'break') {
        pushLine();
        continue;
      }

      if (token.type === 'space') {
        if (!currentSegments.length) continue;

        var spaceWidth = getStyledTextWidth(doc, ' ', defaultFontStyle, fontSize, token);

        if (currentWidth + spaceWidth <= maxWidth) {
          pushToken(' ', token.bold);
        }

        continue;
      }

      var tokenWidth = getStyledTextWidth(doc, token.text, defaultFontStyle, fontSize, token);

      if (currentSegments.length && currentWidth + tokenWidth > maxWidth) {
        pushLine();
      }

      if (!currentSegments.length && tokenWidth > maxWidth) {
        var word = token.text;
        var piece = '';

        for (var c = 0; c < word.length; c++) {
          var nextPiece = piece + word.charAt(c);
          var nextWidth = getStyledTextWidth(doc, nextPiece, defaultFontStyle, fontSize, token);

          if (piece && nextWidth > maxWidth) {
            pushToken(piece, token.bold);
            pushLine();
            piece = word.charAt(c);
          } else {
            piece = nextPiece;
          }
        }

        if (piece) {
          pushToken(piece, token.bold);
        }

        continue;
      }

      pushToken(token.text, token.bold);
    }

    pushLine();

    return lines;
  }

  function createEllipsisLine(doc, line, maxWidth, defaultFontStyle, fontSize, i18n) {
    var text = getRichLineText(line).replace(/\s+$/, '');

    while (text.length > 0 && getStyledTextWidth(doc, text + ' …', defaultFontStyle, fontSize, { bold: false }) > maxWidth) {
      text = text.slice(0, -1);
    }

    return makeRichLineFromSegments([
      {
        text: (text || '').trim() + ' …',
        bold: false
      }
    ]);
  }

  function drawRichTextLine(doc, line, x, y, defaultFontStyle, fontSize, i18n) {
    var preparedLine = cloneRichLine(line);
    var cursorX = x;

    preparedLine.segments.forEach(function (segment) {
      var text = safePdfText(segment.text || '', i18n);
      if (!text) return;

      setPdfFont(doc, getSegmentFontStyle(defaultFontStyle, segment));
      doc.setFontSize(fontSize);
      doc.text(text, cursorX, y);
      cursorX += doc.getTextWidth(text);
    });
  }


  function createProductDescriptionLayout(doc, blocks, width, maxHeight, i18n, scale, allowClip) {
    var ops = [];
    var cursorY = 0;
    var clipped = false;

    scale = scale || 1;

    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      if (!block || !block.text) continue;

      var style = getProductDescriptionBlockStyle(block, i18n, scale);
      var textWidth = width - (style.textIndent || 0);
      var gapBefore = ops.length ? style.gapBefore : 0;
      var defaultFontStyle = style.fontStyle === 'bold' ? 'bold' : 'normal';

      setPdfFont(doc, defaultFontStyle);
      doc.setFontSize(style.fontSize);

      var lines = wrapRichTextLines(doc, block, textWidth, style, i18n);
      if (!lines || !lines.length) continue;

      var requiredHeight = gapBefore + (lines.length * style.lineHeight) + style.gapAfter;

      if (cursorY + requiredHeight <= maxHeight) {
        cursorY += gapBefore;

        ops.push({
          type: 'text',
          blockType: block.type,
          bulletLabel: block.bulletLabel || '•',
          lines: lines,
          y: cursorY,
          fontStyle: style.fontStyle,
          fontSize: style.fontSize,
          lineHeight: style.lineHeight,
          textIndent: style.textIndent || 0
        });

        cursorY += (lines.length * style.lineHeight) + style.gapAfter;
        continue;
      }

      if (!allowClip) {
        return {
          ops: ops,
          height: cursorY,
          clipped: true
        };
      }

      var remainingHeight = maxHeight - cursorY - gapBefore;
      var maxLines = Math.floor(remainingHeight / style.lineHeight);

      if (maxLines > 0) {
        var clippedLines = lines.slice(0, maxLines).map(cloneRichLine);
        var lastIndex = clippedLines.length - 1;

        clippedLines[lastIndex] = createEllipsisLine(
          doc,
          clippedLines[lastIndex],
          textWidth,
          defaultFontStyle,
          style.fontSize,
          i18n
        );

        cursorY += gapBefore;

        ops.push({
          type: 'text',
          blockType: block.type,
          bulletLabel: block.bulletLabel || '•',
          lines: clippedLines,
          y: cursorY,
          fontStyle: style.fontStyle,
          fontSize: style.fontSize,
          lineHeight: style.lineHeight,
          textIndent: style.textIndent || 0
        });

        cursorY += clippedLines.length * style.lineHeight;
      }

      clipped = true;
      break;
    }

    return {
      ops: ops,
      height: cursorY,
      clipped: clipped
    };
  }

  function getProductDescriptionLayout(doc, product, width, maxHeight, i18n) {
    var blocks = getProductDescriptionBlocks(product);

    if (!blocks.length) {
      return {
        ops: [],
        height: 0,
        clipped: false
      };
    }

    var scaleCandidates = [1, 0.96, 0.92, 0.88, 0.84, 0.8, 0.76, 0.72];

    for (var i = 0; i < scaleCandidates.length; i++) {
      var layout = createProductDescriptionLayout(
        doc,
        blocks,
        width,
        maxHeight,
        i18n,
        scaleCandidates[i],
        false
      );

      if (!layout.clipped && layout.height <= maxHeight) {
        return layout;
      }
    }

    return createProductDescriptionLayout(
      doc,
      blocks,
      width,
      maxHeight,
      i18n,
      0.72,
      true
    );
  }

  function drawProductDescriptionLayout(doc, layout, x, y, i18n) {
    if (!layout || !layout.ops || !layout.ops.length) return;

    for (var i = 0; i < layout.ops.length; i++) {
      var op = layout.ops[i];

      doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);

      var currentY = y + op.y;
      var lines = op.lines || [];
      var defaultFontStyle = op.fontStyle === 'bold' ? 'bold' : 'normal';

      if (op.blockType === 'bullet') {
        for (var l = 0; l < lines.length; l++) {
          if (l === 0) {
            setPdfFont(doc, 'normal');
            doc.setFontSize(op.fontSize);
            doc.text(safePdfText(op.bulletLabel || '•', i18n), x, currentY);
          }

          drawRichTextLine(
            doc,
            lines[l],
            x + (op.textIndent || 4.8),
            currentY,
            defaultFontStyle,
            op.fontSize,
            i18n
          );

          currentY += op.lineHeight;
        }
      } else {
        for (var j = 0; j < lines.length; j++) {
          drawRichTextLine(doc, lines[j], x, currentY, defaultFontStyle, op.fontSize, i18n);
          currentY += op.lineHeight;
        }
      }
    }
  }

  function drawTextLines(doc, lines, x, y, lineHeight, i18n) {
    if (!lines || !lines.length) return;

    var safeLines = safePdfLines(lines, i18n);

    for (var i = 0; i < safeLines.length; i++) {
      var line = String(safeLines[i] || '').trim();
      if (line) doc.text(line, x, y);
      y += lineHeight;
    }
  }

  function drawJustifiedText(doc, lines, x, y, width, lineHeight, disableJustify, i18n) {
    if (!lines || !lines.length) return;

    var safeLines = safePdfLines(lines, i18n);

    if (disableJustify) {
      drawTextLines(doc, safeLines, x, y, lineHeight, i18n);
      return;
    }

    for (var i = 0; i < safeLines.length; i++) {
      var line = String(safeLines[i] || '').trim();

      if (!line) {
        y += lineHeight;
        continue;
      }

      var isLastLine = i === safeLines.length - 1;
      var words = line.split(/\s+/).filter(function (word) {
        return word.length > 0;
      });

      if (isLastLine || words.length <= 1 || line.indexOf('•') === 0) {
        doc.text(line, x, y);
        y += lineHeight;
        continue;
      }

      var wordsWidth = 0;
      for (var w = 0; w < words.length; w++) {
        wordsWidth += doc.getTextWidth(words[w]);
      }

      var totalSpacing = width - wordsWidth;
      var gaps = words.length - 1;
      var extraSpace = totalSpacing / gaps;
      var cursorX = x;

      for (var j = 0; j < words.length; j++) {
        doc.text(words[j], cursorX, y);

        if (j < gaps) {
          cursorX += doc.getTextWidth(words[j]) + extraSpace;
        }
      }

      y += lineHeight;
    }
  }

  function drawFittingCenteredText(doc, text, x, y, maxWidth, maxFontSize, minFontSize, i18n) {
    var fontSize = maxFontSize;
    var safeText = safePdfText(text, i18n);

    setPdfFont(doc, 'normal');

    while (fontSize >= minFontSize) {
      doc.setFontSize(fontSize);

      if (doc.getTextWidth(safeText) <= maxWidth) {
        doc.text(safeText, x, y, { align: 'center' });
        return;
      }

      fontSize -= 0.2;
    }

    doc.setFontSize(minFontSize);
    var lines = doc.splitTextToSize(safeText, maxWidth);
    doc.text(lines[0], x, y, { align: 'center' });
  }

  function drawFooterSegments(doc, segments, centerX, y, maxWidth, maxFontSize, minFontSize, i18n) {
    var fontSize = maxFontSize;
    var prepared = [];

    function prepareSegments(size) {
      setPdfFont(doc, 'normal');
      doc.setFontSize(size);

      var totalWidth = 0;
      var list = segments.map(function (segment) {
        var text = safePdfText(segment.text || '', i18n);
        var width = doc.getTextWidth(text);

        totalWidth += width;

        return {
          text: text,
          width: width,
          url: segment.url || null
        };
      });

      return {
        list: list,
        totalWidth: totalWidth
      };
    }

    while (fontSize >= minFontSize) {
      prepared = prepareSegments(fontSize);

      if (prepared.totalWidth <= maxWidth) {
        break;
      }

      fontSize -= 0.2;
    }

    if (!prepared || !prepared.list) {
      prepared = prepareSegments(minFontSize);
    }

    var startX = centerX - (prepared.totalWidth / 2);
    var cursorX = startX;

    setPdfFont(doc, 'normal');
    doc.setFontSize(Math.max(fontSize, minFontSize));
    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);

    prepared.list.forEach(function (segment) {
      if (!segment.text) return;

      if (segment.url && typeof doc.textWithLink === 'function') {
        doc.textWithLink(segment.text, cursorX, y, { url: segment.url });
      } else {
        doc.text(segment.text, cursorX, y);

        if (segment.url && typeof doc.link === 'function') {
          doc.link(cursorX, y - 3.2, segment.width, 4.2, { url: segment.url });
        }
      }

      cursorX += segment.width;
    });
  }

  function drawHeaderFooter(doc, pageNumber, totalPages, i18n) {
    var pageWidth = doc.internal.pageSize.getWidth();
    var pageHeight = doc.internal.pageSize.getHeight();
    var headerHeight = 18;
    var footerHeight = 12;
    var frame = FRAME_MM;
    var contentWidth = pageWidth - (frame * 2);

    doc.setFillColor(COLORS.white[0], COLORS.white[1], COLORS.white[2]);
    doc.rect(0, 0, pageWidth, pageHeight, 'F');

    doc.setFillColor(COLORS.lightGray[0], COLORS.lightGray[1], COLORS.lightGray[2]);
    doc.rect(frame, frame, contentWidth, headerHeight, 'F');

    doc.setFillColor(COLORS.accent[0], COLORS.accent[1], COLORS.accent[2]);
    doc.rect(frame, frame + headerHeight - 1.0, contentWidth, 1.0, 'F');

    setPdfFont(doc, 'bold');
    doc.setFontSize(15);
    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);
    doc.text(safePdfText(i18n.catalogTitle, i18n), frame + 9, frame + 11.5);

    doc.setFillColor(COLORS.lightGray[0], COLORS.lightGray[1], COLORS.lightGray[2]);
    doc.rect(frame, pageHeight - frame - footerHeight, contentWidth, footerHeight, 'F');

    var footerBoxY = pageHeight - frame - footerHeight;
    var footerTextX = pageWidth / 2;
    var footerTextY = footerBoxY + (footerHeight / 2) + 1.2;
    var maxFooterWidth = contentWidth - 8;

    var segments = [
      { text: getDateForFooter(i18n) + ' | © ' + getCurrentYear() + ' GLUETEC GROUP - ' + i18n.footerRights + ' | ' },
      { text: i18n.footerWebsite || 'www.gluetec-group.com', url: i18n.footerWebsiteUrl || 'https://www.gluetec-group.com' },
      { text: ' | ' },
      { text: i18n.footerEmail || 'info.de@gluetec-group.com', url: i18n.footerEmailUrl || 'mailto:info.de@gluetec-group.com' },
      { text: ' | ' + i18n.page + ' - ' + pageNumber + ' / ' + totalPages }
    ];

    var compactSegments = [
      { text: getDateForFooter(i18n) + ' | © ' + getCurrentYear() + ' GLUETEC GROUP | ' },
      { text: i18n.footerWebsite || 'www.gluetec-group.com', url: i18n.footerWebsiteUrl || 'https://www.gluetec-group.com' },
      { text: ' | ' },
      { text: i18n.footerEmail || 'info.de@gluetec-group.com', url: i18n.footerEmailUrl || 'mailto:info.de@gluetec-group.com' },
      { text: ' | ' + i18n.page + ' ' + pageNumber + ' / ' + totalPages }
    ];

    setPdfFont(doc, 'normal');
    doc.setFontSize(7.7);

    var estimatedWidth = segments.reduce(function (sum, segment) {
      return sum + doc.getTextWidth(safePdfText(segment.text || '', i18n));
    }, 0);

    drawFooterSegments(
      doc,
      estimatedWidth <= maxFooterWidth ? segments : compactSegments,
      footerTextX,
      footerTextY,
      maxFooterWidth,
      7.7,
      5.8,
      i18n
    );
  }

  function drawSectionTitle(doc, title, x, y, i18n) {
    setPdfFont(doc, 'bold');
    doc.setFontSize(11);
    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);
    doc.text(safePdfText(title, i18n), x, y);
  }

  function drawDividerGrid() {
    return;
  }

  function getIntroBlocks(collection, i18n) {
    var rawTitle = normalizeWhitespace(collection && collection.title);
    var displayTitle = formatCollectionTitle(rawTitle, i18n);
    var blocks = richTextToBlocks(collection && collection.catalogTextRichText);
    var firstText = blocks.length ? normalizeWhitespace(blocks[0].text) : '';

    if (rawTitle && firstText.toLowerCase() !== rawTitle.toLowerCase()) {
      blocks.unshift({
        type: 'title',
        text: displayTitle,
        segments: [
          {
            text: displayTitle,
            bold: false
          }
        ]
      });
    } else if (rawTitle && blocks.length) {
      blocks[0].type = 'title';
      blocks[0].text = displayTitle;
      blocks[0].segments = [
        {
          text: displayTitle,
          bold: false
        }
      ];
    }

    if (!blocks.length && displayTitle) {
      blocks.push({
        type: 'title',
        text: displayTitle,
        segments: [
          {
            text: displayTitle,
            bold: false
          }
        ]
      });
    }

    return blocks;
  }

  function getIntroBlockStyle(block, i18n) {
    var isPolish = i18n && i18n.language === 'pl';

    if (block.type === 'title') {
      return {
        fontStyle: 'normal',
        fontSize: 23,
        lineHeight: 9.5,
        gapBefore: 0,
        gapAfter: 4.8,
        textIndent: 0,
        bulletIndent: 0
      };
    }

    if (block.type === 'heading') {
      return {
        fontStyle: 'bold',
        fontSize: block.level && block.level <= 2 ? 13.2 : 11.2,
        lineHeight: block.level && block.level <= 2 ? 5.8 : 5.0,
        gapBefore: 5,
        gapAfter: 3,
        textIndent: 0,
        bulletIndent: 0
      };
    }

    if (block.type === 'bullet') {
      return {
        fontStyle: 'normal',
        fontSize: isPolish ? 7.7 : 8.2,
        lineHeight: isPolish ? 3.75 : 3.95,
        gapBefore: 1.1,
        gapAfter: 1.1,
        textIndent: 5.2,
        bulletIndent: 0
      };
    }

    return {
      fontStyle: 'normal',
      fontSize: isPolish ? 7.8 : 8.4,
      lineHeight: isPolish ? 3.85 : 4.05,
      gapBefore: 2.4,
      gapAfter: 1.8,
      textIndent: 0,
      bulletIndent: 0
    };
  }

  function layoutCollectionIntroPages(doc, collection, i18n) {
    var pageWidth = doc.internal.pageSize.getWidth();
    var pageHeight = doc.internal.pageSize.getHeight();
    var x = 14;
    var contentWidth = pageWidth - 28;
    var contentTop = 31;
    var footerTop = pageHeight - FRAME_MM - 12;
    var safeBottom = footerTop - 7;

    var headerMaxHeight = 42;
    var footerMaxHeight = 34;
    var imageGapAfter = 14.5;
    var footerImageGap = 7;

    var pages = [];
    var currentPage = null;
    var cursorY = contentTop;

    var footerFit = collection.footerImage
      ? fitImage(collection.footerImage, contentWidth, footerMaxHeight)
      : { width: 0, height: 0 };

    var footerReserve = footerFit.height > 0 ? footerFit.height + footerImageGap : 0;
    var textBottom = safeBottom - footerReserve;

    function addPage() {
      currentPage = {
        ops: []
      };
      pages.push(currentPage);
      cursorY = contentTop;
    }

    function pageHasOps() {
      return currentPage && currentPage.ops && currentPage.ops.length > 0;
    }

    function addGap(gap) {
      if (!gap) return;

      if (cursorY + gap > textBottom && pageHasOps()) {
        addPage();
      } else {
        cursorY += gap;
      }
    }

    function addTextOp(block, lines, style, startIndex) {
      currentPage.ops.push({
        type: 'text',
        blockType: block.type,
        bulletLabel: block.bulletLabel || '•',
        lines: lines,
        x: x,
        y: cursorY,
        fontStyle: style.fontStyle,
        fontSize: style.fontSize,
        lineHeight: style.lineHeight,
        textIndent: style.textIndent || 0,
        firstSegment: startIndex === 0
      });

      cursorY += lines.length * style.lineHeight;
    }

    addPage();

    if (collection.headerImage) {
      var headerFit = fitImage(collection.headerImage, contentWidth, headerMaxHeight);

      if (headerFit.width > 0 && headerFit.height > 0) {
        currentPage.ops.push({
          type: 'image',
          image: collection.headerImage,
          x: x + ((contentWidth - headerFit.width) / 2),
          y: cursorY,
          width: headerFit.width,
          height: headerFit.height
        });

        cursorY += headerFit.height + imageGapAfter;
      }
    }

    var blocks = getIntroBlocks(collection, i18n);

    for (var b = 0; b < blocks.length; b++) {
      var block = blocks[b];
      var style = getIntroBlockStyle(block, i18n);
      var textWidth = contentWidth - (style.textIndent || 0);

      setPdfFont(doc, style.fontStyle === 'bold' ? 'bold' : 'normal');
      doc.setFontSize(style.fontSize);

      var lines = wrapRichTextLines(doc, block, textWidth, style, i18n);
      if (!lines.length) continue;

      if (pageHasOps()) {
        addGap(style.gapBefore);
      }

      var keepTogether = block.type === 'title' || block.type === 'heading';

      if (keepTogether) {
        var blockHeight = lines.length * style.lineHeight;

        if (cursorY + blockHeight > textBottom && pageHasOps()) {
          addPage();
        }

        addTextOp(block, lines, style, 0);
        addGap(style.gapAfter);
        continue;
      }

      var lineIndex = 0;

      while (lineIndex < lines.length) {
        var availableHeight = textBottom - cursorY;
        var availableLines = Math.floor(availableHeight / style.lineHeight);

        if (availableLines <= 0) {
          addPage();
          continue;
        }

        var take = Math.min(availableLines, lines.length - lineIndex);
        var chunk = lines.slice(lineIndex, lineIndex + take);

        addTextOp(block, chunk, style, lineIndex);
        lineIndex += take;

        if (lineIndex < lines.length) {
          addPage();
        }
      }

      addGap(style.gapAfter);
    }

    if (footerFit.width > 0 && footerFit.height > 0) {
      var footerY = safeBottom - footerFit.height;

      if (cursorY > footerY - footerImageGap && pageHasOps()) {
        addPage();
      }

      var footerImageX = x + ((contentWidth - footerFit.width) / 2);

      currentPage.ops.push({
        type: 'image',
        image: collection.footerImage,
        x: footerImageX,
        y: footerY,
        width: footerFit.width,
        height: footerFit.height
      });
    }

    return pages.length ? pages : [{ ops: [] }];
  }

  function drawCollectionIntroPage(doc, collection, layoutPage, pageNumber, totalPages, i18n) {
    drawHeaderFooter(doc, pageNumber, totalPages, i18n);

    var ops = layoutPage && Array.isArray(layoutPage.ops) ? layoutPage.ops : [];

    for (var i = 0; i < ops.length; i++) {
      var op = ops[i];

      if (op.type === 'image' && op.image && op.image.dataUrl) {
        doc.addImage(op.image.dataUrl, op.image.format, op.x, op.y, op.width, op.height);
        continue;
      }

      if (op.type === 'text') {
        doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);

        var y = op.y;
        var lines = op.lines || [];
        var defaultFontStyle = op.fontStyle === 'bold' ? 'bold' : 'normal';

        if (op.blockType === 'bullet') {
          for (var l = 0; l < lines.length; l++) {
            if (l === 0 && op.firstSegment) {
              setPdfFont(doc, 'normal');
              doc.setFontSize(op.fontSize);
              doc.text(safePdfText(op.bulletLabel || '•', i18n), op.x, y);
            }

            drawRichTextLine(
              doc,
              lines[l],
              op.x + (op.textIndent || 5.2),
              y,
              defaultFontStyle,
              op.fontSize,
              i18n
            );

            y += op.lineHeight;
          }
        } else {
          for (var j = 0; j < lines.length; j++) {
            drawRichTextLine(doc, lines[j], op.x, y, defaultFontStyle, op.fontSize, i18n);
            y += op.lineHeight;
          }
        }
      }
    }
  }

  function drawPropertiesTable(doc, properties, config, i18n) {
    var x = config.x;
    var y = config.y;
    var width = config.width;
    var height = config.height;
    var labelWidth = config.labelWidth;
    var valueWidth = width - labelWidth - 6;
    var titleGap = 4.5;
    var isPolish = i18n && i18n.language === 'pl';

    drawSectionTitle(doc, i18n.properties, x, y, i18n);

    var fontCandidates = isPolish
      ? [7.5, 7.2, 6.9, 6.6, 6.3, 6.0]
      : [8.5, 8.1, 7.7, 7.3, 6.9, 6.5, 6.1];

    var chosen = {
      fontSize: isPolish ? 6.0 : 6.1,
      lineHeight: 3.0,
      padX: 2.0,
      padY: 1.4
    };

    for (var f = 0; f < fontCandidates.length; f++) {
      var fontSize = fontCandidates[f];
      var lineHeight = Math.max(3.0, fontSize * 0.48);
      var padX = fontSize >= 7.5 ? 2.6 : 2.0;
      var padY = fontSize >= 7.5 ? 1.8 : 1.4;
      var totalHeight = titleGap;

      setPdfFont(doc, 'normal');
      doc.setFontSize(fontSize);

      for (var i = 0; i < properties.length; i++) {
        var row = properties[i];
        var labelLines = doc.splitTextToSize(safePdfText(row.label, i18n), labelWidth - padX * 2);
        var valueLines = doc.splitTextToSize(safePdfText(row.value, i18n), valueWidth - padX * 2);
        var rowLineCount = Math.max(labelLines.length, valueLines.length);
        var rowHeight = rowLineCount * lineHeight + padY * 2 + 0.8;
        totalHeight += rowHeight;
      }

      if (totalHeight <= height) {
        chosen = {
          fontSize: fontSize,
          lineHeight: lineHeight,
          padX: padX,
          padY: padY
        };
        break;
      }
    }

    var cursorY = y + titleGap;
    var omitted = false;

    doc.setFontSize(chosen.fontSize);

    for (var j = 0; j < properties.length; j++) {
      var property = properties[j];
      var labelLinesDraw = doc.splitTextToSize(safePdfText(property.label, i18n), labelWidth - chosen.padX * 2);
      var valueLinesDraw = doc.splitTextToSize(safePdfText(property.value, i18n), valueWidth - chosen.padX * 2);
      var rowLineCountDraw = Math.max(labelLinesDraw.length, valueLinesDraw.length);
      var rowHeightDraw = rowLineCountDraw * chosen.lineHeight + chosen.padY * 2 + 0.8;

      if (cursorY + rowHeightDraw > y + height) {
        omitted = true;
        break;
      }

      var fill = (j % 2 === 0) ? COLORS.white : COLORS.lightGray;
      doc.setFillColor(fill[0], fill[1], fill[2]);
      doc.rect(x, cursorY, width, rowHeightDraw, 'F');

      setPdfFont(doc, 'bold');
      doc.setFontSize(chosen.fontSize);
      doc.text(labelLinesDraw, x + chosen.padX, cursorY + chosen.lineHeight + chosen.padY - 0.2);

      setPdfFont(doc, 'normal');
      doc.setFontSize(chosen.fontSize);
      doc.text(valueLinesDraw, x + labelWidth + 3, cursorY + chosen.lineHeight + chosen.padY - 0.2);

      cursorY += rowHeightDraw;
    }

    if (omitted && cursorY + 7 <= y + height) {
      var fillOmitted = ((properties.length) % 2 === 0) ? COLORS.white : COLORS.lightGray;
      doc.setFillColor(fillOmitted[0], fillOmitted[1], fillOmitted[2]);
      doc.rect(x, cursorY, width, 7, 'F');

      setPdfFont(doc, 'bold');
      doc.setFontSize(chosen.fontSize);
      doc.text(safePdfText(i18n.furtherData, i18n), x + chosen.padX, cursorY + 4.4);

      setPdfFont(doc, 'normal');
      doc.setFontSize(chosen.fontSize);
      doc.text(safePdfText(i18n.onRequest, i18n), x + labelWidth + 3, cursorY + 4.4);
    }
  }

  function drawVariantTable(doc, variants, config, i18n) {
    var x = config.x;
    var y = config.y;
    var width = config.width;
    var height = config.height;
    var cursorY = y;
    var padX = 2.0;
    var headerHeight = 8;
    var rowBaseHeight = 7;
    var isPolish = i18n && i18n.language === 'pl';

    var colSku;
    var colVpe;
    var colSize;
    var colType;

    if (isPolish) {
      colSku = 21;
      colVpe = 17;
      colSize = 23;
      colType = width - colSku - colVpe - colSize;
    } else {
      colSku = 23;
      colVpe = 16;
      colSize = 23;
      colType = width - colSku - colVpe - colSize;
    }

    drawSectionTitle(doc, i18n.variants, x, cursorY, i18n);
    cursorY += 4;

    if (cursorY + headerHeight > y + height) return cursorY;

    doc.setFillColor(COLORS.lightGray[0], COLORS.lightGray[1], COLORS.lightGray[2]);
    doc.rect(x, cursorY, width, headerHeight, 'F');

    setPdfFont(doc, 'bold');
    doc.setFontSize(isPolish ? 6.3 : 7.7);
    doc.text(safePdfText(i18n.sku, i18n), x + padX, cursorY + 5);
    doc.text(safePdfText(i18n.vpe, i18n), x + colSku + padX, cursorY + 5);
    doc.text(safePdfText(i18n.packagingSize, i18n), x + colSku + colVpe + padX, cursorY + 5);
    doc.text(safePdfText(i18n.packagingType, i18n), x + colSku + colVpe + colSize + padX, cursorY + 5);

    cursorY += headerHeight;

    var omitted = false;

    for (var i = 0; i < variants.length; i++) {
      var row = variants[i];

      setPdfFont(doc, 'normal');
      doc.setFontSize(isPolish ? 6.7 : 7.4);

      var skuLines = doc.splitTextToSize(safePdfText(row.sku || '–', i18n), colSku - padX * 2);
      var vpeLines = doc.splitTextToSize(safePdfText(row.vpe || '–', i18n), colVpe - padX * 2);
      var sizeLines = doc.splitTextToSize(safePdfText(row.gebindegrosse || '–', i18n), colSize - padX * 2);
      var typeLines = doc.splitTextToSize(safePdfText(row.gebinde || '–', i18n), colType - padX * 2);

      var lineCount = Math.max(skuLines.length, vpeLines.length, sizeLines.length, typeLines.length);
      var rowHeight = Math.max(rowBaseHeight, lineCount * 3.7 + 3);

      if (cursorY + rowHeight > y + height) {
        omitted = true;
        break;
      }

      var fill = (i % 2 === 0) ? COLORS.white : COLORS.lightGray;
      doc.setFillColor(fill[0], fill[1], fill[2]);
      doc.rect(x, cursorY, width, rowHeight, 'F');

      setPdfFont(doc, 'normal');
      doc.setFontSize(isPolish ? 6.7 : 7.4);
      doc.text(skuLines, x + padX, cursorY + 4.3);
      doc.text(vpeLines, x + colSku + padX, cursorY + 4.3);
      doc.text(sizeLines, x + colSku + colVpe + padX, cursorY + 4.3);
      doc.text(typeLines, x + colSku + colVpe + colSize + padX, cursorY + 4.3);

      cursorY += rowHeight;
    }

    if (omitted && cursorY + 8 <= y + height) {
      var omittedFill = ((variants.length) % 2 === 0) ? COLORS.white : COLORS.lightGray;
      doc.setFillColor(omittedFill[0], omittedFill[1], omittedFill[2]);
      doc.rect(x, cursorY, width, 8, 'F');

      setPdfFont(doc, 'bold');
      doc.setFontSize(isPolish ? 6.7 : 7.4);
      doc.text(safePdfText(i18n.moreVariants, i18n), x + padX, cursorY + 4.8);

      setPdfFont(doc, 'normal');
      doc.text(safePdfText(i18n.onRequest, i18n), x + colSku + padX, cursorY + 4.8);
      cursorY += 8;
    }

    return cursorY;
  }

  function getDownloadsBlockHeight(downloads, i18n) {
    if (!downloads || !downloads.length) return 0;

    var lineStep = 5.4;
    var titleHeight = 6;
    var safetyGap = 1.5;

    return titleHeight + (downloads.length * lineStep) + safetyGap;
  }

  function getDownloadsMinimumStartOffset(variants) {
    var variantCount = Array.isArray(variants) ? variants.length : 0;

    if (variantCount >= 6) {
      return Math.min(76, 58 + ((variantCount - 6) * 7));
    }

    return 40;
  }

  function getVariantDownloadGap(variants) {
    var variantCount = Array.isArray(variants) ? variants.length : 0;

    return variantCount >= 6 ? 6 : 3;
  }

  function drawDownloads(doc, downloads, config, downloadIcon, i18n) {
    if (!downloads || !downloads.length) return;

    var x = config.x;
    var y = config.y;
    var width = config.width;
    var height = config.height;
    var cursorY = y;

    if (cursorY + 5 > y + height) return;

    drawSectionTitle(doc, i18n.downloads, x, cursorY, i18n);
    cursorY += 6;

    setPdfFont(doc, 'normal');
    doc.setFontSize(i18n.language === 'pl' ? 8.2 : 8.8);
    doc.setTextColor(0, 0, 0);

    var lineStep = 5.4;
    var iconSize = lineStep - 0.8;
    var iconGap = 1.6;

    for (var i = 0; i < downloads.length; i++) {
      if (cursorY + lineStep > y + height) break;

      var label = safePdfText(String(downloads[i].label || '').toUpperCase(), i18n);
      var url = downloads[i].url;

      var textX = x;
      var availableWidth = width;

      if (downloadIcon && downloadIcon.dataUrl) {
        doc.addImage(
          downloadIcon.dataUrl,
          downloadIcon.format,
          x,
          cursorY - iconSize + 1.2,
          iconSize,
          iconSize
        );

        textX = x + iconSize + iconGap;
        availableWidth = width - iconSize - iconGap;
      }

      var labelLines = doc.splitTextToSize(label, availableWidth);
      if (labelLines.length > 1) {
        labelLines = [labelLines[0]];
      }

      doc.textWithLink(labelLines[0], textX, cursorY, { url: url });
      cursorY += lineStep;
    }

    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);
  }

  function drawProductButton(doc, productUrl, config, i18n) {
    if (!productUrl) return;

    var x = config.x;
    var y = config.y;
    var width = config.width;
    var height = config.height;

    doc.setFillColor(170, 16, 69);
    doc.rect(x, y, width, height, 'F');

    setPdfFont(doc, 'bold');
    doc.setFontSize(i18n.language === 'pl' ? 9.0 : 9.5);
    doc.setTextColor(255, 255, 255);
    doc.text(safePdfText(i18n.productButton, i18n), x + (width / 2), y + (height / 2) + 1.2, { align: 'center' });

    doc.link(x, y, width, height, { url: productUrl });

    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);
  }

  function getTocRowsPerPage() {
    return 27;
  }

  function drawTocPages(doc, tocEntries, tocStartPageNumber, totalPages, i18n) {
    var rowsPerPage = getTocRowsPerPage();
    var tocPageCount = Math.max(1, Math.ceil(tocEntries.length / rowsPerPage));

    var x = 14;
    var pageWidth = doc.internal.pageSize.getWidth();
    var contentWidth = pageWidth - 28;
    var titleY = 34;
    var tableY = 44;
    var firstRowY = 55;
    var rowHeight = 8;

    for (var tocIndex = 0; tocIndex < tocPageCount; tocIndex++) {
      if (tocIndex > 0) {
        doc.addPage();
      }

      var currentPageNumber = tocStartPageNumber + tocIndex;
      var startIndex = tocIndex * rowsPerPage;
      var endIndex = Math.min(startIndex + rowsPerPage, tocEntries.length);

      drawHeaderFooter(doc, currentPageNumber, totalPages, i18n);

      setPdfFont(doc, 'bold');
      doc.setFontSize(18);
      doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);
      doc.text(
        safePdfText(tocIndex === 0 ? i18n.tocTitle : i18n.tocContinuation, i18n),
        x,
        titleY
      );

      doc.setFillColor(COLORS.lightGray[0], COLORS.lightGray[1], COLORS.lightGray[2]);
      doc.rect(x, tableY, contentWidth, 9, 'F');

      setPdfFont(doc, 'bold');
      doc.setFontSize(10);
      doc.text(safePdfText(i18n.name, i18n), x + 3, tableY + 6);
      doc.text(safePdfText(i18n.page, i18n), pageWidth - 28, tableY + 6, { align: 'right' });

      for (var i = startIndex; i < endIndex; i++) {
        var entry = tocEntries[i];
        var localIndex = i - startIndex;
        var rowY = firstRowY + (localIndex * rowHeight);
        var fill = (i % 2 === 0) ? COLORS.white : COLORS.lightGray;

        doc.setFillColor(fill[0], fill[1], fill[2]);
        doc.rect(x, rowY, contentWidth, rowHeight, 'F');

        if (entry.type === 'collection') {
          setPdfFont(doc, 'bold');
          doc.setFontSize(9.2);
        } else {
          setPdfFont(doc, 'normal');
          doc.setFontSize(8.7);
        }

        var titleX = entry.type === 'collection' ? x + 3 : x + 8;
        var titleWidth = entry.type === 'collection' ? contentWidth - 32 : contentWidth - 37;
        var title = entry.title || i18n.untitledProduct;
        var titleLines = fitLines(doc, title, titleWidth, 5, 4.2, i18n);

        doc.text(titleLines[0], titleX, rowY + 5.2);
        doc.text(String(entry.pageNumber), pageWidth - 28, rowY + 5.2, { align: 'right' });
      }
    }
  }

  function drawProductPage(doc, product, pageNumber, totalPages, downloadIcon, i18n) {
    drawHeaderFooter(doc, pageNumber, totalPages, i18n);

    var pageWidth = doc.internal.pageSize.getWidth();
    var pageHeight = doc.internal.pageSize.getHeight();

    var x = 14;
    var contentWidth = pageWidth - 28;
    var gap = 8;
    var colWidth = (contentWidth - gap) / 2;

    var contentOffsetY = 4;
    var titleY = 29 + contentOffsetY;
    var topY = 38 + contentOffsetY;

    var footerTop = pageHeight - FRAME_MM - 12;
    var safeBottom = footerTop - 6;

    var isPolish = i18n.language === 'pl';
    var minBottomHeight = isPolish ? 111 : 108;
    var gapBetween = 6;
    var maxTopTextHeight = safeBottom - topY - minBottomHeight - gapBetween - 10;

    var descriptionLayout = getProductDescriptionLayout(
      doc,
      product,
      colWidth,
      maxTopTextHeight,
      i18n
    );

    var topHeight = Math.max(72, descriptionLayout.height + 11);
    var bottomY = topY + topHeight + gapBetween;
    var bottomHeight = safeBottom - bottomY;

    setPdfFont(doc, 'bold');
    doc.setFontSize(17);
    doc.setTextColor(COLORS.darkText[0], COLORS.darkText[1], COLORS.darkText[2]);

    var titleLines = fitLines(doc, product.title || i18n.untitledProduct, contentWidth, 10, 6, i18n);
    doc.text(titleLines, x, titleY);

    drawDividerGrid(doc, x, topY, contentWidth, topHeight, bottomHeight, gap);

    var leftTopX = x;
    var rightTopX = x + colWidth + gap;
    var leftBottomX = x;
    var rightBottomX = x + colWidth + gap;

    drawSectionTitle(doc, i18n.description, leftTopX, topY, i18n);

    drawProductDescriptionLayout(
      doc,
      descriptionLayout,
      leftTopX,
      topY + 6,
      i18n
    );

    drawSectionTitle(doc, i18n.productImage, rightTopX, topY, i18n);

    if (product.image) {
      var imageBoxHeight = Math.max(58, topHeight - 10);
      var fitted = fitImage(product.image, colWidth - 8, imageBoxHeight);

      if (fitted.width > 0 && fitted.height > 0) {
        var imageX = rightTopX + ((colWidth - fitted.width) / 2);
        var imageY = topY + 4 + ((imageBoxHeight - fitted.height) / 2);
        doc.addImage(product.image.dataUrl, product.image.format, imageX, imageY, fitted.width, fitted.height);
      }
    }

    drawPropertiesTable(doc, product.properties || [], {
      x: leftBottomX,
      y: bottomY,
      width: colWidth,
      height: bottomHeight,
      labelWidth: isPolish ? 42 : 34
    }, i18n);

    var buttonHeight = 10;
    var buttonGap = 6;
    var buttonY = bottomY + bottomHeight - buttonHeight;
    var rightContentBottomY = buttonY - buttonGap;

    var variants = product.variants || [];
    var downloads = product.downloads || [];
    var hasDownloads = downloads.length > 0;
    var downloadsBlockHeight = hasDownloads ? getDownloadsBlockHeight(downloads, i18n) : 0;
    var variantDownloadGap = hasDownloads ? getVariantDownloadGap(variants) : 0;
    var downloadsMaxStartY = hasDownloads
      ? Math.max(bottomY, rightContentBottomY - downloadsBlockHeight)
      : rightContentBottomY;
    var variantAreaHeight = hasDownloads
      ? Math.max(0, downloadsMaxStartY - bottomY - variantDownloadGap)
      : Math.max(0, rightContentBottomY - bottomY);

    var variantEndY = drawVariantTable(doc, variants, {
      x: rightBottomX,
      y: bottomY,
      width: colWidth,
      height: variantAreaHeight
    }, i18n);

    if (hasDownloads) {
      var downloadsMinStartY = bottomY + getDownloadsMinimumStartOffset(variants);
      var downloadsStartY = Math.max(variantEndY + variantDownloadGap, downloadsMinStartY);

      if (downloadsStartY > downloadsMaxStartY) {
        downloadsStartY = downloadsMaxStartY;
      }

      drawDownloads(doc, downloads, {
        x: rightBottomX,
        y: downloadsStartY,
        width: colWidth,
        height: Math.max(0, rightContentBottomY - downloadsStartY)
      }, downloadIcon, i18n);
    }

    drawProductButton(doc, product.productUrl, {
      x: rightBottomX,
      y: buttonY,
      width: colWidth,
      height: buttonHeight
    }, i18n);
  }

  function countProductsInSections(sections) {
    var count = 0;

    sections.forEach(function (section) {
      count += section.products.length;
    });

    return count;
  }

  function createTocEntries(sections, firstContentPageNumber, i18n) {
    var entries = [];
    var currentPageNumber = firstContentPageNumber;

    sections.forEach(function (section) {
      entries.push({
        type: 'collection',
        title: formatCollectionTitle(section.collection.title, i18n),
        pageNumber: currentPageNumber
      });

      currentPageNumber += section.introPageCount;

      section.products.forEach(function (product) {
        entries.push({
          type: 'product',
          title: product.title,
          pageNumber: currentPageNumber
        });

        currentPageNumber += 1;
      });
    });

    return entries;
  }

  async function buildGeneratedCatalog(jsPDFConstructor, sections, downloadIcon, frontPagesCount, backPagesCount, payload, i18n) {
    var doc = new jsPDFConstructor({
      orientation: 'p',
      unit: 'mm',
      format: 'a4',
      compress: true,
      putOnlyUsedFonts: true
    });

    await registerPdfFonts(doc, payload);

    sections.forEach(function (section) {
      section.introLayoutPages = layoutCollectionIntroPages(doc, section.collection, i18n);
      section.introPageCount = Math.max(1, section.introLayoutPages.length);
    });

    var productCount = countProductsInSections(sections);
    var tocEntryCount = sections.length + productCount;
    var tocPagesCount = Math.max(1, Math.ceil(tocEntryCount / getTocRowsPerPage()));
    var introPagesCount = sections.reduce(function (sum, section) {
      return sum + section.introPageCount;
    }, 0);

    var totalPages = frontPagesCount + tocPagesCount + introPagesCount + productCount + backPagesCount;
    var tocStartPageNumber = frontPagesCount + 1;
    var firstContentPageNumber = frontPagesCount + tocPagesCount + 1;
    var tocEntries = createTocEntries(sections, firstContentPageNumber, i18n);

    drawTocPages(doc, tocEntries, tocStartPageNumber, totalPages, i18n);

    var currentPageNumber = firstContentPageNumber;

    sections.forEach(function (section) {
      section.introLayoutPages.forEach(function (layoutPage) {
        doc.addPage();
        drawCollectionIntroPage(doc, section.collection, layoutPage, currentPageNumber, totalPages, i18n);
        currentPageNumber += 1;
      });

      section.products.forEach(function (product) {
        doc.addPage();
        drawProductPage(doc, product, currentPageNumber, totalPages, downloadIcon, i18n);
        currentPageNumber += 1;
      });
    });

    return doc.output('arraybuffer');
  }

  async function mergeFinalPdf(frontPdfUrl, generatedBytes, backPdfUrl) {
    var PDFLib = await loadPdfLib();
    var finalDoc = await PDFLib.PDFDocument.create();

    if (frontPdfUrl) {
      var frontBytes = await fetchArrayBuffer(frontPdfUrl);
      var frontDoc = await PDFLib.PDFDocument.load(frontBytes);
      var frontPages = await finalDoc.copyPages(frontDoc, frontDoc.getPageIndices());

      frontPages.forEach(function (page) {
        finalDoc.addPage(page);
      });
    }

    var generatedDoc = await PDFLib.PDFDocument.load(generatedBytes);
    var generatedPages = await finalDoc.copyPages(generatedDoc, generatedDoc.getPageIndices());

    generatedPages.forEach(function (page) {
      finalDoc.addPage(page);
    });

    if (backPdfUrl) {
      var backBytes = await fetchArrayBuffer(backPdfUrl);
      var backDoc = await PDFLib.PDFDocument.load(backBytes);
      var backPages = await finalDoc.copyPages(backDoc, backDoc.getPageIndices());

      backPages.forEach(function (page) {
        finalDoc.addPage(page);
      });
    }

    return finalDoc.save();
  }

  async function getFixedPdfPageCounts(frontPdfUrl, backPdfUrl) {
    var PDFLib = await loadPdfLib();
    var frontPagesCount = 0;
    var backPagesCount = 0;

    if (frontPdfUrl) {
      var frontBytes = await fetchArrayBuffer(frontPdfUrl);
      var frontDoc = await PDFLib.PDFDocument.load(frontBytes);
      frontPagesCount = frontDoc.getPageCount();
    }

    if (backPdfUrl) {
      var backBytes = await fetchArrayBuffer(backPdfUrl);
      var backDoc = await PDFLib.PDFDocument.load(backBytes);
      backPagesCount = backDoc.getPageCount();
    }

    return {
      frontPagesCount: frontPagesCount,
      backPagesCount: backPagesCount
    };
  }

  async function createCatalogPdfBytes(root) {
    var payload = parsePayload(root);
    var i18n = getI18n(payload);
    var products = uniqueProductsFromPayload(root);

    if (!products.length) {
      throw new Error('Keine Produkte im Warenkorb gefunden.');
    }

    var sections = buildCatalogSections(products, i18n);

    if (!sections.length) {
      throw new Error('Keine Produktgruppen für den Katalog gefunden.');
    }

    var jsPDFConstructor = await loadJsPDF();
    var enriched = await enrichCatalogAssets(sections, payload.downloadIconUrl);
    var pageCounts = await getFixedPdfPageCounts(payload.frontPdfUrl, payload.backPdfUrl);

    var generatedBytes = await buildGeneratedCatalog(
      jsPDFConstructor,
      enriched.sections,
      enriched.downloadIcon,
      pageCounts.frontPagesCount,
      pageCounts.backPagesCount,
      payload,
      i18n
    );

    return mergeFinalPdf(payload.frontPdfUrl, generatedBytes, payload.backPdfUrl);
  }

  async function fetchCartState() {
    var response = await fetch(getCartUrl(), {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    });

    if (!response.ok) {
      throw new Error('Cart state request failed');
    }

    return response.json();
  }

  function scheduleEmptyCartRefresh() {
    window.clearTimeout(cartCheckTimer);

    cartCheckTimer = window.setTimeout(async function () {
      try {
        var cart = await fetchCartState();

        if (cart && typeof cart.item_count === 'number' && cart.item_count === 0) {
          window.location.reload();
        }
      } catch (error) {
        console.warn('GT Cart Refresh Check Error:', error);
      }
    }, 700);
  }

  async function generateCatalog(root, mode, button) {
    var payload = parsePayload(root);
    var i18n = getI18n(payload);
    var products = uniqueProductsFromPayload(root);

    if (!products.length) {
      alert(i18n.emptyCart);
      return;
    }

    var allButtons = root ? root.querySelectorAll('.gt-cart-pdf-export__button') : [];
    var originalText = button.textContent;
    var previewWindow = null;

    try {
      Array.prototype.forEach.call(allButtons, function (btn) {
        btn.disabled = true;
      });

      button.textContent = i18n.loading;

      if (mode === 'open') {
        previewWindow = window.open('', '_blank');

        if (previewWindow) {
          previewWindow.document.open();
          previewWindow.document.write(
            '<!doctype html><html><head><title>' +
            i18n.openWindowTitle +
            '</title></head><body style="font-family:Arial,sans-serif;padding:24px;">' +
            i18n.loading +
            '</body></html>'
          );
          previewWindow.document.close();
        }
      }

      var finalBytes = await createCatalogPdfBytes(root);
      var blob = new Blob([finalBytes], { type: 'application/pdf' });
      var blobUrl = URL.createObjectURL(blob);
      var filename = i18n.filenamePrefix + '-' + getTodayForFilename() + '.pdf';

      if (mode === 'open') {
        if (previewWindow) {
          previewWindow.location.href = blobUrl;
        } else {
          window.open(blobUrl, '_blank');
        }
      } else {
        var link = document.createElement('a');
        link.href = blobUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      }

      window.setTimeout(function () {
        URL.revokeObjectURL(blobUrl);
      }, 120000);
    } catch (error) {
      if (previewWindow && !previewWindow.closed) {
        previewWindow.close();
      }

      console.error('GT Catalog PDF Error:', error);
      alert(i18n.createFailed);
    } finally {
      Array.prototype.forEach.call(allButtons, function (btn) {
        btn.disabled = false;
      });

      button.textContent = originalText;
    }
  }

  document.addEventListener('click', function (event) {
    var exportButton = event.target && event.target.closest ? event.target.closest('.gt-cart-pdf-export__button') : null;

    if (exportButton) {
      var root = getRootFromNode(exportButton);
      if (!root) return;

      event.preventDefault();
      event.stopPropagation();

      var mode = exportButton.getAttribute('data-mode') || 'download';
      generateCatalog(root, mode, exportButton);
      return;
    }

    var target = event.target && event.target.closest ? event.target.closest('button, a') : null;
    if (!target) return;

    var cartContext = target.closest('form[action*="/cart"], cart-items, main-cart-items, cart-drawer, .cart, .cart-page, .cart__items, .cart-items, .drawer__inner, .cart-drawer, .cart-drawer__content');
    if (!cartContext) return;

    var signature = [
      target.getAttribute('aria-label') || '',
      target.getAttribute('name') || '',
      target.getAttribute('data-cart-remove') || '',
      target.className || '',
      target.textContent || ''
    ].join(' ').toLowerCase();

    var isCartMutation =
      !!target.closest('cart-remove-button') ||
      target.matches('a[href*="/cart/change"], [data-cart-remove], [data-remove], [name="remove"], .quantity__button') ||
      /remove|entfernen|delete|trash|minus|decrease|menge|quantity|qty|usuń|usun|kosz|ilość|ilosc|zmniejsz/.test(signature);

    if (isCartMutation) {
      scheduleEmptyCartRefresh();
    }
  }, true);

  document.addEventListener('change', function (event) {
    var el = event.target;
    if (!el || !el.closest) return;

    var cartContext = el.closest('form[action*="/cart"], cart-items, main-cart-items, cart-drawer, .cart, .cart-page, .cart__items, .cart-items, .drawer__inner, .cart-drawer, .cart-drawer__content');
    if (!cartContext) return;

    var name = (el.name || '').toLowerCase();

    if (name.indexOf('updates') !== -1 || name.indexOf('quantity') !== -1) {
      scheduleEmptyCartRefresh();
    }
  }, true);
})();